export function validationPassword(pass) {
  return pass?.length >= 6;
}
